import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { ProfilePhotoModel } from "../../models/user/profile-photo.model";
import { UserRepository } from "../../repositories/user.repository";

export class GetProfilePhotoUseCase implements UseCase<void, ProfilePhotoModel> {
    constructor(private userRepository: UserRepository) { }
    execute(): Observable<ProfilePhotoModel> {
        return this.userRepository.getProfilePhoto();
    }
}
